// hooks/useErrorPopup.ts
import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import type { RootState } from "@app/store";

export function useErrorPopup(callback: (message: string, details?: Record<string, any>) => void) {
  const logs = useSelector((state: RootState) => state.logger.logs);
  const lastErrorId = useRef<string | null>(null);

  useEffect(() => {
    const latestError = [...logs].reverse().find((log) => log.level === 'error');

    if (latestError && latestError.id !== lastErrorId.current) {
      lastErrorId.current = latestError.id;
      // 🛠 Фикс: отложенный вызов, чтобы избежать конфликта с рендером
      setTimeout(() => {
        callback(latestError.message, latestError.details);
      }, 0);
    }
  }, [logs, callback]);
}
